import { Text } from '@change/ds-core-ui';

import { useDecisionMakerProfilePageData } from '#src/app/pages/decisionMakerProfile/pageContext';

export const EndorsementsOverview: React.FC = () => {
	const {
		data: { displayName, lastName, enrichedData },
	} = useDecisionMakerProfilePageData();

	const summary = enrichedData?.endorsementsOverview?.summary;
	const headingText = `Who's supporting ${lastName ?? displayName}?`;

	return !summary ? null : (
		<div data-qa="dm-endorsements-overview" className="flex flex-col gap-2">
			<Text as="h2" variant="heading" size="small" className="mb-2">
				{headingText}
			</Text>
			<Text variant="body">{summary}</Text>
		</div>
	);
};
